import { Ingredient, Instruction, Recipe, Tag, ProfilePreview } from '@/types';
import { calculateMaximalUnit } from '@/utils/measuringUnits';

export function structuredRecipe(recipe: Recipe): object
{
    const days = Math.floor(recipe.preparationTime / 1440);
    const hours = Math.floor((recipe.preparationTime % 1440) / 60);
    const minutes = recipe.preparationTime % 60;
    const prepTime = "P" + days + "DT" + hours + "H" + minutes + "M";

    return {
        "@context": "https://schema.org",
        "@type": "Recipe",
        "name": recipe.title,
        "description": recipe.description,
        "image": recipe.titleImage ? [
            recipe.titleImage.originalUrl,
        ] : null,
        "datePublished": recipe.createdAt,
        "author": structuredAuthor(recipe.author),
        "totalTime": prepTime,
        "recipeYield": recipe.servings,
        "recipeIngredient": recipe.ingredients?.map((ingredient) => structuredIngredient(ingredient)),
        "recipeInstructions": recipe.instructions?.map((instruction) => structuredInstruction(instruction)),
        "keywords": recipe.tags?.map((tag) => structuredTag(tag)),
    }
}

function structuredAuthor(user: ProfilePreview): object
{
    return {
        "@type": "Person",
        "name": user.name,
    }
}

function structuredIngredient(ingredient: Ingredient): string
{
    const {quantity, unit} = calculateMaximalUnit(ingredient.amount, ingredient.measuringType);

    return `${quantity} ${unit.symbol} ${ingredient.food.name}`;
}

function structuredInstruction(instruction: Instruction): object
{
    return {
        "@type": "HowToStep",
        "text": instruction.description,
        "image": instruction.image?.originalUrl,
    }
}

function structuredTag(tag: Tag): string
{
    return tag.name;
}
